const colors = {
  primary800: "#363870",
  primary650: "#8082C5",
  primary500: "#7075E9",
  primary300: "#C6C9F4",
  primary100: "#F1F2FE",
  primary50: "#f8f8ff",
  blue500: "#7075E9",
  button: "#6563DD",
  success: "#35A15A",
  success550: "#1F8943",
  success500: "#35A15A",
  success100: "#E6F3EB",
  error550: "#D66662",
  error500: "#ED827E",
  error100: "#FCF0EF",
  attention550: "#D9916E",
  attention500: "#EDAA8A",
  attention100: "#FCF4F1"
};
// eslint-disable-next-line
export default {
  ...colors,
  primary800: "#FFFFFF",
  primary650: "#C6C9F4",
  primary300: "#8182C5",
  primary200: "#5C5EA2",
  primary100: "#363970",
  primary50: "#181931",
  white: "#232345",
  success100: "#1C2F37",
  error100: "#3A2A3D",
  attention100: "#3A303F",

  card: {
    background: "#212345"
  },
  select: {
    selectedTextColor: "#8182C5"
  },
  icon: {
    borderColor: colors.primary800
  },
  gradient: "rgba(0, 0, 0, 0.5);",
  tokenDescGradient: "linear-gradient(180deg, rgba(248, 248, 255, 0) 0%, #181931 100%)",
  noNftGradient: "-webkit-linear-gradient(rgba(255, 255, 255, 0), rgb(20 22 49) 57.65%);"
};
